import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CiudadRow=({ciudad, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{ciudad.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{ciudad.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/ciudad/"+ciudad.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(ciudad.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={ciudad.idEstatus==1?'x':'check'} link  size="large" 
                                                color={ciudad.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(ciudad.id)} 
                                            />
                                        }
                                        content={ciudad.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default CiudadRow;